import { render, staticRenderFns } from "./commonUploadVideo.vue?vue&type=template&id=498b2d82&"
import script from "./commonUploadVideo.vue?vue&type=script&lang=js&"
export * from "./commonUploadVideo.vue?vue&type=script&lang=js&"
import style0 from "./commonUploadVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports